import 'css-chunk:src/app/containers/Home/CommunitiesView/CommunityDetailView/CommunityPrograms.scss';export default {
  "CommunityPrograms": "_CommunityPrograms_t2pzk_1",
  "text": "_text_t2pzk_1",
  "field": "_field_t2pzk_5"
};